import SDKMessageBus from '../utility/message-bus';
import { Maybe } from 'maybe-not';

export default function promptForMFA(
    messageBus: SDKMessageBus,
    moduleId: string,
    platformCapabilities: Set<string>
) {
    if (!platformCapabilities.has('promptForMFA')) {
        return;
    }

    return function(promptOptions: { message?: string } = {}): Promise<void> {
        const mfaOptions: { moduleId?: string; message?: string } = { moduleId, ...promptOptions };

        return messageBus
            .sendRequest<void>('promptForMFA', Maybe.just(mfaOptions).map(JSON.stringify))
            .then(() => {
                return;
            })
            .catch(response => {
                throw new Error(response.message);
            });
    };
}
